import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {MaterialService} from "./materialService";
import {AppStateService} from "../../services/appStateService";

export class MaterialUIService {
    private uiService: UIService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private materialService: MaterialService;
    private appStateService: AppStateService;

    constructor() {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.materialService = new MaterialService();
        this.appStateService = new AppStateService();

        this.initializeModal();
        this.populatePreview();
    }

    private initializeModal()
    {
    }

    private hasOptions(): boolean {
        return this.productDataStore.getAvailableOptionsByName('materials').length > 0;
    }

    private populatePreview()
    {
        if (!this.hasOptions()) {
            return false;
        }
        const previewElements = this.uiService.getElementByActionName('preview-material');
        const records = this.productDataStore.getAvailableOptionsByName('materials');
        const selectedProduct = this.productDataStore.getProductId();

        records.some((record) => {
            if (selectedProduct === record.id) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            record.attributes.name
                        )
                    );

                    previewElements.forEach((previewElement) => {
                    previewElement.append(element);
                });
                return true;
            }
        });
    }

    public initializeComponent()
    {
        if (!this.hasOptions()) {
            this.appStateService.setAppSettingTemplateFlag('app', 'materialsComponent', false);
            this.uiService.refreshElementsInModule('app');
            return false;
        }
        const records = this.productDataStore.getAvailableOptionsByName('materials');
        const selectedProduct = this.productDataStore.getProductId();

        records.forEach((record) => {
            const option = this.createOption(record);

            if (record.id === selectedProduct) {
                this.uiService.setSelectedOption(option);
            }
            option.addEventListener('click', (event: any) => {
                this.reloadProductWithNewMaterial(record);
            });
        });
    }

    private createOption(record)
    {
        const option = this.uiService.createConfiguratorOption('material');

        if (record.attributes.basePriceDifference.raw !== 0) {
            var priceDifferenceText = '';

            if (record.attributes.basePriceDifference.raw > 0) {
                priceDifferenceText += '+';
            }
            priceDifferenceText += record.attributes.basePriceDifference.formatted;

            if (record.id === this.productDataStore.getProductId()) {
                priceDifferenceText = '';
            }

            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute('nf-value-key', 'price', option),
                priceDifferenceText
            );
        }
        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            record.id
        );

        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'name', option),
            record.attributes.name
        );

        return option;
    }

    private reloadProductWithNewMaterial(material)
    {
        if (material.id === this.productDataStore.getProductId()) {
            return false;
        }

        const hingeOptionSelector: any = this.uiService.getElementByAttribute('nf-template-input', 'productHingeSideOption');
        localStorage.setItem('shape', JSON.stringify({
            height: Math.floor(this.productDataStore.getAttributeByName('height')),
            width: Math.floor(this.productDataStore.getAttributeByName('width')),
            bottomPanel: this.productDataStore.getAttributeByName('bottomPanel'),
            unit: this.productDataStore.getSelectedOptionIdByName('unit'),
            hingeSide: this.productDataStore.getSelectedOptionIdByName(
                this.uiService.getAttributeFromElement(hingeOptionSelector, 'nf-option-name')
            ),
        }));

        localStorage.setItem('relationship', JSON.stringify(
            this.productDataStore.getAllSelectedOptions()
        ));

        window.location.href = '/' + material.attributes.productUrl;
    }
}
